import React from "react";
import { BiLoaderCircle } from "react-icons/bi";

type LoaderProps = {
  /** Sit in the page's own box instead of covering the screen, so the header stays clickable. */
  inline?: boolean;
};

const Loader: React.FC<LoaderProps> = ({ inline = false }) => {
  return (
      <div
        className={
          inline
            ? "flex flex-1 items-center justify-center"
            : "fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
        }
      >
      <div className="bg-white p-6 rounded-xl shadow-xl flex flex-col items-center gap-4 w-64">
        <div className="spinner-wrapper">
          <div className="double-ball">
            <div className="ball yellow" />
            <div className="ball dark" />
          </div>
        </div>
        <p className="text-gray-700 font-semibold">Loading...</p>
      </div>
    </div>

  );
};

export default Loader;
